import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReportRoutingModule } from './report-routing.module';
import { MatCardModule } from '@angular/material/card';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { SharedModule } from 'src/app/shared/modules/shared.module';
import { DeviceReportComponent } from './device-report/device-report.component';
import { BillingComponent } from './billing/billing.component';
import { AlertsReportComponent } from './alerts-report/alerts-report/alerts-report.component';
import { AlertLinksComponent } from './alerts-report/alerts-report/alert-links/alert-links.component';
import { AlertDevicesComponent } from './alerts-report/alerts-report/alert-devices/alert-devices.component';
import { MonitoringStreamComponent } from './monitoring-stream/monitoring-stream/monitoring-stream.component';
import { DeviceListReportComponent } from './device-list-report/device-list-report.component';
import { CellularReportCenterComponent } from './cellular-report-center/cellular-report-center.component';
import { CellularUsageTableComponent } from './cellular-report-center/cellular-usage-table/cellular-usage-table.component';
import { CellularBillingThresholdDialogComponent } from './cellular-report-center/dialogs/cellular-billing-threshold-dialog.component';
import { CellularBillingReviewDialogComponent } from './cellular-report-center/dialogs/cellular-billing-review-dialog.component';
import { CellularReportReviewComponent } from './cellular-report-center/cellular-report-review/cellular-report-review.component';
import { CellularReviewDecisionDialogComponent } from './cellular-report-center/cellular-report-review/cellular-review-decision-dialog.component';
import { OverlayUsageTableComponent } from './cellular-report-center/overlay-usage-table/overlay-usage-table.component';
import { OverlayBundlesComponent } from './cellular-report-center/overlay-bundles/overlay-bundles.component';
import { OverlayCustomCodeDialogComponent } from './cellular-report-center/dialogs/overlay-custom-code-dialog.component';
import { OverlayCostComparisonDialogComponent } from './cellular-report-center/dialogs/overlay-cost-comparison-dialog.component';
import { BillingPricingComponent } from './cellular-report-center/billing-pricing/billing-pricing.component';
import { ConfigurationDeleteDialogComponent } from './cellular-report-center/dialogs/configuration-delete-dialog.component';
import { CellularPoolingComponent } from './cellular-report-center/cellular-pooling/cellular-pooling.component';
import { DuplicateMacReconciliationComponent } from './cellular-report-center/duplicate-mac-reconciliation/duplicate-mac-reconciliation.component';
import { BillingMspGroupsComponent } from './cellular-report-center/billing-msp-groups/billing-msp-groups.component';

@NgModule({
  declarations: [
    DuplicateMacReconciliationComponent,
    BillingMspGroupsComponent,
    CellularPoolingComponent,
    ConfigurationDeleteDialogComponent,
    BillingPricingComponent,
    OverlayCostComparisonDialogComponent,
    OverlayCustomCodeDialogComponent,
    OverlayBundlesComponent,
    OverlayUsageTableComponent,
    CellularReportReviewComponent,
    CellularReviewDecisionDialogComponent,
    DeviceReportComponent,
    BillingComponent,
    AlertsReportComponent,
    AlertLinksComponent,
    AlertDevicesComponent,
    MonitoringStreamComponent,
    DeviceListReportComponent,
    CellularReportCenterComponent,
    CellularUsageTableComponent,
    CellularBillingThresholdDialogComponent,
    CellularBillingReviewDialogComponent
  ],
  imports: [
    CommonModule,
    ReportRoutingModule,
    MatCardModule,
    MatTableModule,
    MatTabsModule,
    SharedModule
  ],
  entryComponents: [
    ConfigurationDeleteDialogComponent,
    OverlayCostComparisonDialogComponent,
    OverlayCustomCodeDialogComponent,
    CellularReviewDecisionDialogComponent,
    CellularBillingThresholdDialogComponent,
    CellularBillingReviewDialogComponent
  ]
})
export class ReportModule { }
